import { getImageUrl } from "../helpers/mediaUrl";

export default class customer_all_offers {
  constructor() {
    this.bindEvents();
  }

  bindEvents = () => {
    this.loadAllOffers();
  };

  buildOfferCard = (offer) => {
    const imgUrl = getImageUrl(offer.Image_Url || "");

    const goToPage = (offer.Go_To_Page || offer.go_to_page || "").toLowerCase();
    const offerData = offer.offer_data || offer.data || offer.Offer_Data;

    let linkHref = `${baseURL}customer/allOffers`;
    if (goToPage === "vendor" && offerData) {
      linkHref = `${baseURL}customer/productListing/${offerData}`;
    } else if (goToPage === "category" && offerData) {
      linkHref = `${baseURL}customer/vendorListingPage/${offerData}`;
    } else if (!goToPage && offer.Vendor_URL) {
      // Fallback: Use joined Vendor_URL if explicit routing is missing
      linkHref = `${baseURL}customer/productListing/${offer.Vendor_URL}`;
    }

    const endDate = offer.end_date
      ? offer.end_date.split(" ")[0]
      : "";

    return `
      <div class="offer-card-wrap col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
        <a href="${linkHref}" class="text-decoration-none d-block h-100">
          <div class="offer-card h-100" style="
            border-radius: 16px;
            overflow: hidden;
            background: #fff;
            box-shadow: 0 2px 12px rgba(0,0,0,0.08);
            transition: transform 0.2s, box-shadow 0.2s;
          " onmouseover="this.style.transform='translateY(-4px)';this.style.boxShadow='0 8px 24px rgba(0,0,0,0.14)';" onmouseout="this.style.transform='';this.style.boxShadow='0 2px 12px rgba(0,0,0,0.08)';">
            <div style="position:relative; overflow:hidden; background:#f8f8f8; height:180px;">
              <img
                src="${imgUrl}"
                alt="${offer.Offer_Name}"
                onerror="this.src='${baseURL}assets/default.png'; this.style.objectFit='contain';"
                style="width:100%; height:100%; object-fit:cover;"
              />
              <div style="position:absolute; top:10px; left:10px; background:#ff385c; color:#fff; font-size:0.75rem; font-weight:700; padding:3px 10px; border-radius:20px;">
                OFFER
              </div>
            </div>
            <div class="p-3">
              <h6 style="font-weight:700; color:#3d4152; margin-bottom:4px;">${offer.Offer_Name}</h6>
              ${endDate ? `<p class="text-muted mb-0" style="font-size:0.8rem;">Valid till: ${endDate}</p>` : ""}
            </div>
          </div>
        </a>
      </div>`;
  };

  loadAllOffers = () => {
    const container = $(".all-offers-grid");
    container.html(`
      <div class="col-12 text-center py-5">
        <div class="spinner-border text-danger" role="status"><span class="sr-only">Loading...</span></div>
      </div>`);

    $.ajax({
      url: baseURL + "api/customer/Homepage/getAllOffers",
      type: "GET",
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        container.empty();
        const offers = Array.isArray(result) ? result : [];
        if (offers.length === 0) {
          container.html(`
            <div class="col-12">
              <div class="text-center py-5">
                <i class="fa fa-tags fa-3x mb-3" style="color:#ff385c; opacity:0.4;"></i>
                <h5 style="color:#3d4152;">No offers available right now</h5>
                <p class="text-muted">Please check back in some time.</p>
              </div>
            </div>`);
          return;
        }
        offers.forEach((offer) => {
          container.append(this.buildOfferCard(offer));
        });
      },
      error: () => {
        container.html(`
          <div class="col-12">
            <div class="text-center py-5">
              <i class="fa fa-exclamation-triangle fa-3x mb-3" style="color:#ff385c; opacity:0.4;"></i>
              <h5 style="color:#3d4152;">Unable to load offers</h5>
              <p class="text-muted">Please refresh and try again.</p>
            </div>
          </div>`);
      },
    });
  };
}

